/* eslint-disable */
export default {
  feedbackHeader: 'Lähetä palaute',
  back: 'Takaisin',
  revert: 'Palauta',
  instruction:
    'Arvostamme palautettasi. Jos sovelluksen käytössä esiintyy ongelmia, haluat ehdottaa ominaisuutta tai ilmoittaa virheestä, autamme mielellämme.',
  fillForm: 'Täytä alla oleva lomake ja napsauta ',
  useMailBox: ' tai lähetä pyyntösi suoraan sähköpostilla osoitteeseen ',
  email: 'Oma sähköpostiosoite',
  reply: '(jotta voimme vastata sinulle)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Palautteen aihe',
  topicPlaceHolder: 'Valitse vaihtoehto',
  bugReport: 'Virheraportti',
  featureRequest: 'Ominaisuusehdotus',
  others: 'Muut',
  subject: 'Aihe',
  subjectPlaceHolder: 'Kerro, miten voimme auttaa',
  description: 'Täysi kuvaus',
  descriptionPlaceHolder: 'Anna mahdollisimman paljon tietoja',
  send: 'Lähetä palautetta',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
